<template>
  <b-container fluid id="login">
    <b-row class="h-100">
      <b-col align-self="center" md="6">
        <div class="text-center">
          <img class="brand" src="@/assets/img/logo-pedale.png" @click="goHome()">

        </div>
        <b-row align-h="center">
          <b-col lg="8" xl="6">
            <div class="text-center mb-2 mb-md-4">
              <div>
                <h4>Digite sua nova senha</h4>
                <p v-show="!this.$route.params.token" class="text-muted">Cole o token recebido no seu e-mail no campo abaixo:</p>
              </div>
            </div>

            <!--===== Form Token =====-->
            <el-form
              id="newPasswordForm"
              :model="newPasswordForm"
              status-icon
              :rules="newPasswordFormRules"
              ref="newPasswordForm"
              class="recover-pass-form">

              <el-form-item label="Token" prop="token" v-show="!this.$route.params.token">
                <el-input
                  v-model.trim="newPasswordForm.token"
                  autocomplete="off"
                  placeholder="Cole o token aqui">
                </el-input>
              </el-form-item>

              <el-form-item label="E-mail" prop="email">
                <el-input
                  v-model.trim="newPasswordForm.email"
                  v-show="!this.$route.params.email"
                  type="email"
                  placeholder="E-mail">
                </el-input>
              </el-form-item>

              <el-form-item label="Nova Senha" prop="newPassword">
                <el-input
                  v-model.trim="newPasswordForm.newPassword"
                  type="password"
                  placeholder="Digite a sua nova senha">
                </el-input>
              </el-form-item>

                <el-form-item label="Confirmar Nova Senha" prop="confirmPassword">
                    <el-input
                        v-model.trim="newPasswordForm.confirmPassword"
                        type="password"
                        placeholder="Repita a sua nova senha">
                    </el-input>
                </el-form-item>

              <el-form-item>
                <el-button
                  @click="submitNewPasswordForm('newPasswordForm')"
                  :loading="loading"
                  type="primary"
                  class="mt-3 d-block w-100 font-weight-bold"
                  round>
                  Alterar Senha
                </el-button>
              </el-form-item>
            </el-form>
            <!--===== End Recover Pass =====-->

            <div class="text-center">
              <router-link to="/login">Voltar ao login</router-link>
            </div>

          </b-col>
        </b-row>
      </b-col>
      <b-col :style="{backgroundImage : `url(${bgLogin})`}" class="bg-cover bg-center bg-primary">
        <router-link to="/" class="← back-to-site">← Voltar ao site</router-link>
      </b-col>
    </b-row>
  </b-container>

</template>

<script>
    import bgLogin from '@/assets/img/login.jpg';

    export default {
        name: 'NewPassword',
        data() {
            return {
                loading: false,
                bgLogin,
                newPasswordForm: {
                    token: this.$route.params.token,
                    email: (!this.$store.state.auth.mail ? this.$route.params.email : this.$store.state.auth.mail),
                    newPassword: '',
                    confirmPassword: ''
                },
                newPasswordFormRules: {
                    token: [
                        {required: true, message: 'Por favor, digite o token', trigger: 'blur'}
                    ],
                    email: [
                        {required: true, message: 'Por favor, preencha seu e-mail', trigger: 'blur'},
                        {
                            type: 'email',
                            message: 'Por favor, digite um endereço de e-mail válido',
                            trigger: ['blur']
                        }
                    ],
                    newPassword: [
                        {required: true, validator: this.checkPass, trigger: 'blur'}
                    ],
                    confirmPassword: [
                        {required: true, validator: this.checkConfirmPassword, trigger: 'blur'}
                    ],
                },
            };
        },
        methods: {
            //TODO Criar uma camada de proteção para impedir o acesso direto a rota /recuperar-senha/token

            submitNewPasswordForm(form) {

                this.$refs[form].validate((valid) => {

                    this.loading = true;

                    if (valid) {
                        const {token, email, newPassword, confirmPassword} = this.newPasswordForm;

                        this.axios.post(`${process.env.VUE_APP_BASE_URL + process.env.VUE_APP_API_V1}/auth/reset_password`, {
                            token,
                            email,
                            newPassword,
                            confirmPassword
                        }).then(() => {
                            this.$message({
                                message: 'Senha foi alterada com sucesso. Por favor, efetue o login com sua nova senha.',
                                type: 'success'
                            });
                            this.loading = false;
                            this.$router.push('/login')

                        }).catch(err => {
                            alert(err)
                            if (err.response.data.error === 'existingEmail') {
                                this.existingEmail = true;
                            }
                            this.loading = false;
                        });
                    }
                    else {
                        this.$message.error('Preencha os campos corretamente!');
                        this.loading = false;
                        return false;
                    }
                });
            },

            checkPass(rule, value, callback) {
                if (!value) {
                    return callback(new Error('Digite sua nova senha'));
                }
                if (value.length < 6) {
                    callback(new Error('Mínimo de 6 caracteres'));
                }
                if (value.length > 24) {
                    callback(new Error('Máximo de 24 caracteres'));
                }

                callback();
            },

            checkConfirmPassword(rule, value, callback) {
                if (!value) {
                    return callback(new Error('Por favor, confirme sua senha'));
                }
                if (value !== this.newPasswordForm.newPassword) {
                    callback(new Error('As senhas não conferem!'));
                }

                callback();
            },

            goHome() {
                this.$router.push('/');
            }
        },
        computed: {
          loggedIn() {
              return this.$store.state.auth.status.loggedIn;
          },
        },
        created() {
          if (this.loggedIn) {
              this.$router.push('/painel/inicio')
          }
        },
        watch: {
        }
    }
</script>
